import React, {ReactElement, ReactNode} from "react";

export interface NavigationProps {
    left: ReactNode,
    right: ReactNode
}

export function Navigation(props: NavigationProps): ReactElement {
    return (
        <div className="flex items-center h-[90px] bg-white">
            <div className="flex-grow px-11 flex items-center gap-4">
                {props.left}
            </div>
            <div className="flex-none pr-8 flex items-center gap-4">
                {props.right}
            </div>
        </div>
    );
}

interface NavigationLeftProps {
    children: ReactNode | ReactNode[]
}

function NavigationLeft(props: NavigationLeftProps): ReactElement {
    return <>props.children</>;
}

interface NavigationLeftProps {
    children: ReactNode | ReactNode[]
}

function NavigationRight(props: NavigationLeftProps): ReactElement {
    return <>props.children</>;
}

Navigation.Left = NavigationLeft;
Navigation.Right = NavigationRight;
